import { createContext, useContext } from "react";

export interface BaselineFhrRefreshContextValue {
  /** When false, BaselineFhr skips fetch (e.g. drawer closed but still mounted). */
  refreshWhen: boolean;
  /** Bump after a successful FHR save so baseline refetches while the drawer stays open. */
  baselineRefreshKey: number;
}

const DEFAULT_BASELINE_FHR_REFRESH: BaselineFhrRefreshContextValue = {
  refreshWhen: true,
  baselineRefreshKey: 0,
};

export const BaselineFhrRefreshContext = createContext<BaselineFhrRefreshContextValue>(
  DEFAULT_BASELINE_FHR_REFRESH,
);

export function useBaselineFhrRefresh(): BaselineFhrRefreshContextValue {
  return useContext(BaselineFhrRefreshContext);
}
